import React from "react"
import autobind from "class-autobind"
import { Dialog, FlatButton, TextField } from "material-ui"
import strings from "../../../../localization/strings"
import { IClientContactDocument } from "../../../../models"
import AccountStore from "../../../../stores/AccountStore"
import * as utils from "../../../../helpers/utils"
interface IProps {
    clientId: string
    handleClose(): void
    handleAdd(client: IClientContactDocument): void
}
interface IState {
    firstName: string
    errorFirstName: string
    lastName: string
    errorLastName: string
}

export default class AddClientContactDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            firstName: "",
            errorFirstName: "",
            lastName: "",
            errorLastName: "",
        }
        autobind(this)
    }

    getClientContactPayload() {
        const payload = {
            Id: utils.guid(),
            FirstName: this.state.firstName.trim(),
            LastName: this.state.lastName.trim(),
            ClientId: this.props.clientId,
            Active: true,
            AccountId: AccountStore.getCurrentAccount().Id,
        } as IClientContactDocument
        return payload
    }

    handleSave() {
        if (this.checkValidate()) this.props.handleAdd(this.getClientContactPayload())
    }

    checkValidate() {
        let isValidate = true
        if (!this.state.firstName.trim()) {
            this.setState({ errorFirstName: strings.First_Name_cannot_be_empty })
            isValidate = false
        } else {
            this.setState({ errorFirstName: "" })
        }
        if (!this.state.lastName.trim()) {
            this.setState({ errorLastName: strings.Last_Name_cannot_be_empty })
            isValidate = false
        } else {
            this.setState({ errorLastName: "" })
        }
        
        return isValidate
    }

    render() {
        return (
        <Dialog
            open
            title={strings.Add_Contact}
            titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
            actions={[
            <FlatButton
                label={strings.CANCEL}
                secondary
                onClick={this.props.handleClose}
            />,
            <FlatButton
                label={strings.SAVE}
                primary
                onClick={this.handleSave}
            />
            ]}
        >
            <div style={{ paddingRight: 20, paddingLeft: 20 }}>
                <TextField
                    floatingLabelText={strings.First_Name}
                    value={this.state.firstName}
                    onChange={(e, value) => { this.setState({ firstName: value }, () => this.checkValidate()) }}
                    errorText={this.state.errorFirstName}
                    errorStyle={{ position: "absolute", bottom: -10 }}
                    fullWidth={true}
                />
                <TextField
                    floatingLabelText={strings.Last_Name}
                    value={this.state.lastName}
                    onChange={(e, value) => { this.setState({ lastName: value }, () => this.checkValidate()) }}
                    errorText={this.state.errorLastName}
                    errorStyle={{ position: "absolute", bottom: -10 }}
                    fullWidth={true}
                />
            </div>
        </Dialog>
        )
    }
}